import Era from 'src/components/dashboard_era/era.jsx';
import { FilesProvider } from 'src/context/files.jsx';
import { ErasProvider } from 'src/context/eras.jsx';

const Page = () => {
	return (
		<FilesProvider>
			<ErasProvider>
				<Era />
			</ErasProvider>
		</FilesProvider>
	);
};

export default Page;

